/** @format */

import React, { FC, ReactElement } from 'react';
import { OplSimCardServiceTypeItemForm } from '../OplSimCardServiceTypeItemEdit';
import GridItem from '../../../../../components/Grid/GridItem';
import { SimpleSelect } from '../../../../../components/Adescom/SimpleSelect';
import { ServicesAction } from '../../../../../modules/features/FeaturesReducers';
import CustomInputExt from '../../../../../components/CustomInput/CustomInputExt';
import { getBooleanElementList } from '../../../../lib/search/listTableHeader/HeaderBooleanCheckBoxSelectList';

export const MappedComponentForm: FC<OplSimCardServiceTypeItemForm> = ({
    serviceUseType,
    simCardServiceTypeStack,
    onChangeSelectEvent,
    onChangeEvent,
    operatorType,
    groupList,
}): ReactElement => {
    return (
        <>
            <GridItem xs={6} style={{ paddingTop: '8px' }}>
                <SimpleSelect
                    label="prov:feature.use_type"
                    fieldName="useType"
                    required={true}
                    elements={serviceUseType}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.useType}
                    callback={onChangeSelectEvent}
                />
            </GridItem>
            <GridItem xs={12}>
                <CustomInputExt
                    formControlProps={{ fullWidth: true }}
                    required={true}
                    labelText="prov:feature.component_description"
                    name="description"
                    value={simCardServiceTypeStack.description}
                    onChange={onChangeEvent}
                />
            </GridItem>
            <GridItem xs={12}>
                <CustomInputExt
                    formControlProps={{ fullWidth: true }}
                    labelText="prov:feature.comment"
                    name="comment"
                    value={simCardServiceTypeStack.comment}
                    onChange={onChangeEvent}
                />
            </GridItem>
            <GridItem xs={12} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.group_name"
                    fieldName="groupId"
                    required={true}
                    elements={groupList}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.groupId}
                    callback={onChangeSelectEvent}
                />
            </GridItem>
            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.operator_mvne"
                    fieldName="operatorType"
                    required={true}
                    elements={operatorType}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.operatorType}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.sync_usage"
                    fieldName="syncUsage"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.syncUsage ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>
            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.sync_detail"
                    fieldName="syncDetails"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.syncDetails ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.visible"
                    fieldName="visibleFlag"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.visibleFlag ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.single_shot"
                    fieldName="singleShotFlag"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.singleShotFlag ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>
            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.cycle_component"
                    fieldName="cycle"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.cycle === -1 ? 2 : 1}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.generate_cdr"
                    fieldName="generateCdr"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.generateCdr ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.generate_cdr_with_billsec_equal_amount"
                    fieldName="cdrOnAmount"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.cdrOnAmount === 1 ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            <GridItem xs={6} style={{ paddingTop: '20px' }}>
                <SimpleSelect
                    label="prov:feature.allow_waiting_activation"
                    fieldName="allowWaitingForActivation"
                    required={true}
                    elements={getBooleanElementList()}
                    dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                    selectedValue={simCardServiceTypeStack.allowWaitingForActivation ? 1 : 2}
                    callback={onChangeSelectEvent}
                />
            </GridItem>

            {simCardServiceTypeStack.allowWaitingForActivation && (
                <>
                    <GridItem xs={6} style={{ paddingTop: '20px' }}>
                        <SimpleSelect
                            label="prov:feature.allow_zone"
                            fieldName="zoneCheck"
                            required={true}
                            elements={getBooleanElementList()}
                            dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                            selectedValue={simCardServiceTypeStack.zoneCheck ? 1 : 2}
                            callback={onChangeSelectEvent}
                        />
                    </GridItem>

                    <GridItem xs={6} style={{ paddingTop: '20px' }}>
                        <SimpleSelect
                            label="prov:feature.allow_mcc"
                            fieldName="mccCheck"
                            required={true}
                            elements={getBooleanElementList()}
                            dispatchName={ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_EDIT_UPDATE_SELECT}
                            selectedValue={simCardServiceTypeStack.mccCheck ? 1 : 2}
                            callback={onChangeSelectEvent}
                        />
                    </GridItem>
                </>
            )}
        </>
    );
};
